(function () {
    'use strict';

    angular.module('document')
        .service('DocumentService', ['$rootScope', '$http', 'DocumentConfigService', 'IEFallbackService', 'dialogService',
            function ($rootScope, $http, DocumentConfigService, IEFallbackService, dialogService) {
                var object = {};

                return {
                    ////////////////
                    getCurrentObject: function () {
                        return object;
                    },
                    ////////////////
                    setCurrentObject: function (obj) {
                        object = obj;
                    },
                    ////////////////
                    deleteDocument: function (ID, fileName, onSuccess, onError) {
                        $http.delete(DocumentConfigService.deleteDocumentPath + ID + '/' + btoa(fileName))
                            .success(function (data, status, headers, config) {
                                if (angular.isDefined(onSuccess)) {
                                    onSuccess(data, status, headers, config);
                                }
                            })
                            .error(function (data, status, headers, config) {
                                if (angular.isDefined(onError)) {
                                    onError(data, status, headers, config);
                                }
                            });
                    },
                    ////////////////
                    getDocumentList: function (objectID, onSuccess, onError) {
                        $http.get(DocumentConfigService.getDocumentListPath + objectID)
                            .success(function (data, status, headers, config) {
                                if (angular.isDefined(onSuccess)) {
                                    onSuccess(data, status, headers, config);
                                }
                            })
                            .error(function (data, status, headers, config) {
                                if (angular.isDefined(onError)) {
                                    onError(data, status, headers, config);
                                }
                            });
                    },
                    ////////////////
                    getDocument: function (docId, onSuccess, onError) {
                        $http.get(DocumentConfigService.getDocumentPath + docId)
                            .success(function (data, status, headers, config) {
                                if (angular.isDefined(onSuccess)) {
                                    onSuccess(data, status, headers, config);
                                }
                            })
                            .error(function (data, status, headers, config) {
                                if (angular.isDefined(onError)) {
                                    onError(data, status, headers, config);
                                }
                            });
                    },
                    ////////////////
                    uploadDocuments: function (OID, inputElement, droppedFile, overwrite, onSuccess) {
                        var that = this;
                        if (typeof FormData === 'undefined') {//IE fallback
                            if (droppedFile !== null) inputElement = droppedFile;
                            IEFallbackService.upload(DocumentConfigService.uploadDocumentPath + OID + '/' + overwrite, inputElement, onSuccess);
                            return;
                        }

                        var formData = new FormData();
                        if (droppedFile === null) {
                            for (var i = 0; i < inputElement.files.length; i++) {
                                formData.append('file', inputElement.files[i]);
                            }
                        } else {
                            formData.append('file', droppedFile);
                        }

                        $http.post(DocumentConfigService.uploadDocumentPath + OID + '/' + overwrite, formData, {
                            transformRequest: angular.identity,
                            headers: { 'Content-Type': undefined }
                        }).success(function (data) {
                            if (data.insufficientPrivileges) {
                                dialogService.error('Nepakanka teisių');
                            } else if (data.hasError) {
                                dialogService.error('Įvyko klaida prisegant dokumentą.');
                            } else if (data.needsPermission) {
                                dialogService.confirmCustom('layout/dialogs/documentOverwriteDialog.html', data.results)
                                    .then(function () {
                                        if (droppedFile === null) {
                                            that.uploadDocuments(OID, inputElement, null, true, onSuccess);
                                        } else {
                                            that.uploadDocuments(OID, null, droppedFile, true, onSuccess);
                                        }
                                    });
                            }
                            $rootScope.$broadcast('refreshDocuments');
                            if (onSuccess) {
                                onSuccess();
                            }
                        }).error(function () {
                            if (angular.isDefined(onError)) {
                                $rootScope.$broadcast('refreshDocuments');
                                dialogService.error('Įvyko klaida prisegant dokumentą.');
                            }
                        });
                    }
                };
            }]);

})();
